"use client";

import React, { useRef, useEffect } from "react";
import Image from "next/image";
import useEmblaCarousel from "embla-carousel-react";
import Autoplay from "embla-carousel-autoplay";

const nos_data = [
  {
    img: "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/b-one.webp",
    label: "Part 1 - Financial Planning, Performance & Analytics",
  },
  {
    img: "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/b-two.webp",
    label: "Part 2 - Strategic Financial Management",
  },
];

const CMA_SECTIONS = [
  {
    short_title: "Part 1: Introduction",
    description: "Your Roadmap to the Future of Finance",
    planningImage:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/financial_planning_intro.webp",
  },
  {
    short_title: "Part 1: Section A",
    description: "External Financial Reporting Decision",
    planningImage:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/part1_section_A.webp",
  },
  {
    short_title: "Part 1: Section B",
    description: "Planning, Budgeting & Forecasting",
    planningImage:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/part1_section_B.webp",
  },
  {
    short_title: "Part 1: Section C",
    description: "Performance Management",
    planningImage:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/part1_section_C.webp",
  },
  {
    short_title: "Part 1: Section D",
    description: "Cost Management",
    planningImage:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/part1_section_D.webp",
  },
  {
    short_title: "Part 1: Section E",
    description: "Internal Controls",
    planningImage:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/part1_section_E.webp",
  },
  {
    short_title: "Part 2: Section A",
    description: "Financial Statement Analysis",
    planningImage:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/part2_section_A.webp",
  },
  {
    short_title: "Part 2: Section B",
    description: "Corporate Finance",
    planningImage:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/part2_section_B.webp",
  },
  {
    short_title: "Part 2: Section C",
    description: "Decision Analysis",
    planningImage:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/part2_section_C.webp",
  },
  {
    short_title: "Part 2: Section D",
    description: "Risk Management",
    planningImage:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/part2_section_D.webp",
  },
  {
    short_title: "Part 2: Section E",
    description: "Investment Decisions",
    planningImage:
      "https://ik.imagekit.io/mileseducation/miles_website/accounting/cma-visit/part2_section_E.webp",
  },
];

const exams = CMA_SECTIONS?.map((e) => ({
  img: "https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit/b-one.webp",
  label: `${e.short_title} — ${e.description}`,
  src: e.planningImage,
  short_title: e.short_title,
  description: e.description,
}));

const CmaEquivalentNew = () => {
  const autoplayDeskRef = useRef(
    Autoplay({ delay: 3000, stopOnInteraction: false, stopOnMouseEnter: true }),
  );
  const [emblaDeskRef, emblaDeskApi] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      dragFree: false,
      containScroll: "trimSnaps",
      slidesToScroll: 1,
    },
    [autoplayDeskRef.current],
  );

  const autoplayMobileRef = useRef(
    Autoplay({ delay: 3000, stopOnInteraction: false, stopOnMouseEnter: true }),
  );
  const [emblaMobileRef, emblaMobileApi] = useEmblaCarousel(
    {
      loop: true,
      align: "start",
      dragFree: false,
      containScroll: "trimSnaps",
      slidesToScroll: 1,
    },
    [autoplayMobileRef.current],
  );

  useEffect(() => {
    emblaDeskApi && autoplayDeskRef.current?.play?.();
    emblaMobileApi && autoplayMobileRef.current?.play?.();
  }, [emblaDeskApi, emblaMobileApi]);

  return (
    <>
      <div className="w-full bg-[#061A2F] relative mx-auto">
        <div className="main_container mx-auto px-5 md:pt-12 md:pb-12 pt-8 pb-8">
          <h2 className="text-center font-semibold leading-tight">
            <span className="relative inline-block text-[20px] md:text-[32px] tracking-[-0.01em]">
              <span className="bg-[linear-gradient(91deg,#39F_81.57%,#FFBA08_106.77%)] bg-clip-text text-transparent">
                U.S. CMA =
              </span>
              <span className="text-white">
                {" "}
                Certified Management
                <br className="md:hidden block" /> Accountant
              </span>
            </span>
          </h2>

          <p className="md:mt-6 mt-5 text-center text-white text-sm font-medium tracking-[0.56px]">
            2 Exams | 8 Months
          </p>

          {/* Desktop Box */}
          <div
            className="rounded-[16px] border border-[#39F] backdrop-blur-[4px] md:p-5 mt-4 md:block hidden relative"
            style={{
              background:
                "linear-gradient(0deg, rgba(51,153,255,0.10) 0%, rgba(51,153,255,0.10) 100%), rgba(255,255,255,0.04)",
            }}
          >
            <h3 className="text-white md:text-2xl font-medium text-center">
              Learn from VARUN JAIN, World’s favourite CMA Instructor
            </h3>
            <div className="flex justify-center items-center">
              <p className="text-white md:text-lg font-medium text-center">
                with 100MM+ YouTube views
              </p>
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit-new/youtube.webp"
                alt="Youtube Icon"
                className="ml-2"
                width={20}
                height={20}
                loading="lazy"
              />
            </div>

            <div className="grid grid-cols-2 gap-2 w-full mt-3">
              {nos_data?.map((item) => (
                <div key={item.label} className="flex flex-col gap-2 mt-2">
                  <div className="flex gap-2 items-center">
                    <Image
                      src={item.img}
                      alt={item.label}
                      width={24}
                      height={24}
                      loading="lazy"
                    />
                    <p className="text-white font-medium text-xs md:text-base leading-[1.2] whitespace-pre-line">
                      {item.label}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Desktop Slider */}
            <div className="mt-3">
              <div
                ref={emblaDeskRef}
                className="embla overflow-hidden cursor-grab active:cursor-grabbing"
              >
                <div className="embla__container flex">
                  {exams?.map((item, index) => (
                    <div
                      key={`desk-slide-${index}`}
                      className="embla__slide relative flex-[0_0_10%] min-w-0 ml-2 select-none"
                    >
                      <Image
                        src={item.src}
                        alt={item.label}
                        className="rounded-[8px] w-full h-full object-cover min-h-[124px] border border-[#868686]"
                        width={111}
                        height={124}
                        loading="lazy"
                        draggable={false}
                      />
                      <div className="absolute left-0 bottom-0 w-full rounded-[5px] bg-[linear-gradient(0deg,#0C1F33_0%,rgba(12,31,51,0)_100%)] p-2">
                        <p className="font-bold leading-3 text-white text-[10px]">
                          {item.short_title}
                        </p>
                        <p className="font-bold leading-3 text-white text-[8px] mt-[2px]">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <p
              className="rounded-[8px] border border-[#39F] backdrop-blur-[4px] md:text-base font-semibold text-black text-center py-[0.5px] px-5 absolute left-1/2 -translate-x-1/2 bottom-[-15px] md:block hidden"
              style={{
                background:
                  "linear-gradient(0deg,#FFB801 0%,#FFB801 100%), #FFF",
              }}
            >
              80%+ CMAs in India are Miles Alumni
            </p>
          </div>

          {/* Mobile Box */}
          <div
            className="rounded-[16px] border border-[#39F] backdrop-blur-[4px] p-3 mt-4 md:hidden block"
            style={{
              background:
                "linear-gradient(0deg, rgba(51,153,255,0.10) 0%, rgba(51,153,255,0.10) 100%), rgba(255,255,255,0.04)",
            }}
          >
            <h3 className="text-white text-center leading-6 text-sm">
              <span className="text-[#D4D4D4]">Learn from</span>{" "}
              <span className="block font-bold text-[32px]">VARUN JAIN</span>{" "}
              World’s favourite CMA Instructor
            </h3>
            <div className="flex justify-center items-center mt-1">
              <p className="text-white text-xs font-medium text-center">
                with 100MM+ YouTube views
              </p>
              <Image
                src="https://ik.imagekit.io/mileseducation/miles_website/accounting/cpa-visit-new/youtube.webp"
                alt="Youtube Icon"
                className="ml-2"
                width={20}
                height={20}
                loading="lazy"
              />
            </div>

            <div className="grid grid-cols-1 gap-1 w-full mt-3">
              {nos_data?.map((item) => (
                <div key={item.label} className="flex flex-col gap-2 mt-2">
                  <div className="flex gap-2 items-center">
                    <Image
                      src={item.img}
                      alt={item.label}
                      width={24}
                      height={24}
                      loading="lazy"
                    />
                    <p className="text-white font-bold text-xs md:text-base leading-[1.2] whitespace-pre-line">
                      {item.label}
                    </p>
                  </div>
                </div>
              ))}
            </div>

            {/* Mobile Slider */}
            <div className="mt-4">
              <div
                ref={emblaMobileRef}
                className="embla overflow-hidden cursor-grab active:cursor-grabbing"
              >
                <div className="embla__container flex">
                  {exams?.map((item, index) => (
                    <div
                      key={`mobile-slide-${index}`}
                      className="embla__slide relative flex-[0_0_33.33%] min-w-0 ml-2 select-none"
                    >
                      <Image
                        src={item.src}
                        alt={item.label}
                        className="rounded-[8px] w-full h-full object-cover min-h-[111px] border border-[#868686]"
                        width={86}
                        height={111}
                        loading="lazy"
                        draggable={false}
                      />
                      <div className="absolute left-0 bottom-0 w-full rounded-[5px] bg-[linear-gradient(0deg,#0C1F33_0%,rgba(12,31,51,0)_100%)] p-2">
                        <p className="font-bold leading-3 text-white text-[8px]">
                          {item.short_title}
                        </p>
                        <p className="font-bold leading-3 text-white text-[6px]">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <p
            className="rounded-[8px] border border-[#39F] backdrop-blur-[4px] text-sm font-semibold text-black text-center py-[2px] px-5 md:hidden block my-5"
            style={{
              background: "linear-gradient(0deg,#FFB801 0%,#FFB801 100%), #FFF",
            }}
          >
            80%+ CMAs in India are Miles Alumni
          </p>
        </div>
      </div>
    </>
  );
};

export default CmaEquivalentNew;
